module.exports = __webpack_public_path__ + "static/media/ic_general_road_dark.44809688.svg";